import React from 'react';
import { useTranslate } from 'hooks/use-translate';
import { BaseTemplatePrint } from '../base-template-print';

interface TemplatePrintProps {
  userPatientProfilePrescriptionID: string;
  documentURL: string | null | undefined;
}
export const TemplateDownloadForClinic: React.FC<React.PropsWithChildren<TemplatePrintProps>> = ({
  documentURL,
  userPatientProfilePrescriptionID,
}) => {
  const { tp } = useTranslate();
  if (!documentURL) return null;

  return (
    <BaseTemplatePrint
      userPatientProfilePrescriptionID={userPatientProfilePrescriptionID}
      documentURL={documentURL}
      remarks={tp('activity-patient-prescription-download-for-clinic')}
    />
  );
};
